<template>
  <div class="bg-secondary-3 rounded py-3 px-4">
    <div v-if="!isMobile" class="row py-2 px-2">
      <div
        class="col col-sm col-12 font-16 font-weight-bold d-flex justify-content-center align-items-center"
      >
        Región
      </div>
      <div class="col-11">
        <div class="row">
          <div
            v-for="(l, index) in labels"
            :key="`label-header-${index}`"
            class="col col-sm col-12 pt-2 pl-3 pl-md-4 text-center color-gray border-left"
          >
            <div class="font-16 font-weight-bold">{{ l.label }}</div>
          </div>
        </div>
      </div>
    </div>
    <div
      v-for="(item, index) in items"
      :key="`progress-item-${index}`"
      class="row bg-white rounded mb-2 p-2"
    >
      <div
        class="col col-sm col-12 color-black font-16 font-weight-bold d-flex justify-content-center align-items-center py-3"
      >
        {{ item.regionName }}
      </div>
      <div class="col-11">
        <div class="row">
          <div
            v-for="(value, indexValue) in item.values"
            :key="`progress-item-value-${indexValue}`"
            :class="{ 'border-left py-3': !isMobile }"
            class="col col-sm col-12 pt-2 pl-3 pl-md-4"
          >
            <div v-if="isMobile" class="color-gray font-14">
              {{ value.label }}:
            </div>
            <div
              class="color-black font-16"
              :class="{ 'text-center': !isMobile }"
            >
              {{ value.value | currency }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="hasItems" class="row bg-green py-2 px-2 rounded">
      <div
        class="col col-sm col-12 color-white font-16 font-weight-bold d-flex justify-content-center align-items-center"
      >
        Total
      </div>
      <div class="col-11">
        <div class="row">
          <div
            v-for="(l, index) in labels"
            :key="`label-item-${index}`"
            :class="{ 'border-left d-flex justify-content-between align-items-center flex-column': !isMobile }"
            class="col col-sm col-12 pt-2 pl-3 pl-md-4 color-white"
          >
            <div v-if="l.visible" class="font-16" :class="{ 'text-center' : !isMobile}">
              {{ l.label }}{{ isMobile ? ':' : '' }}
            </div>
            <div v-if="l.visible" class="font-16" :class="{ 'text-center' : !isMobile}">
              {{ totals(l.label) | currency }}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ProgressInfoSummary',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isMobile() {
      return this.$store.getters['$_app/getIsMobileDensity'];
    },
    hasItems() {
      return this.items && this.items.length > 0;
    },
    labels() {
      return this.items[0]?.values;
    },
    totals() {
      return (label) => {
        let total = 0;
        for (let item of this.items) {
          total += item.values.find((x) => x.label === label)?.value ?? 0;
        }
        return total;
      };
    },
  },
};
</script>
